/*
 * @Author: Han
 * @Date: 2022-01-13 13:32:28
 * @LastEditors: Han
 * @LastEditTime: 2022-01-18 15:19:47
 * @FilePath: \console\console\src\http\moudules\role.js
 */
import axios from '../axios'
// 查询角色菜单
export const roleMenu = (data) => {
  return axios({
    url: '/con/manage/menu/get',
    method: 'GET',
    data
  })
}
// 添加角色
export const saveRole = (data) => {
  return axios({
    url: '/con/manage/role/save',
    method: 'POST',
    data
  })
}
// 角色查询对应菜单
export const idGetRoleMenu = (data) => {
  return axios({
    url: '/con/manage/role/get_role_menu',
    method: 'POST',
    data
  })
}
// 更新角色权限
export const updateRole = (data) => {
  return axios({
    url: '/con/manage/role/update',
    method: 'POST',
    data
  })
}
// 删除角色
export const delRole = (data) => {
  return axios({
    url: '/con/manage/role/delete',
    method: 'POST',
    data
  })
}
// 查看角色列表
export const getAutherList = (data) => {
  return axios({
    url: '/con/manage/role/list',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/role.js